import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import MAndEManageCBTeamWidget from '../../widgets/assessment/MAndEManageCBTeamWidget'
import { GetAssessmentMAndEManageCBTeam } from '../../redux/actions/assessment'

export default function MAndEManageCBTeam() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionStorage.getItem('project_code')

  useEffect(() => {
    if (projectCode) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: 'ไม่พบ รหัสโครงการ กรุณาเลือกโครงการก่อน',
      })
    }
  }, [projectCode])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await GetAssessmentMAndEManageCBTeam(projectCode)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi isShowGoButton />
      {schema && <MAndEManageCBTeamWidget schema={schema.forms.form} projectCode={projectCode} />}
    </SidebarProposal>
  )
}

const mock = {
  header: 'จัดการทีม CB',
  form: {
    preName: {
      name: 'preName',
      label: 'คำนำหน้าชื่อ',
      value: null,
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก ชื่อ',
        },
      ],
    },
    firstName: {
      name: 'firstName',
      label: 'ชื่อ',
      value: null,
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก ชื่อ',
        },
      ],
    },
    lastName: {
      name: 'lastName',
      label: 'สกุล',
      value: null,
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก สกุล',
        },
      ],
    },
    position: {
      name: 'position',
      label: 'ตำแหน่ง',
      value: null,
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก ตำแหน่ง',
        },
      ],
    },
    mobileNumber: {
      name: 'mobileNumber',
      label: 'เบอร์ติดต่อ',
      value: null,
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก เบอร์ติดต่อ',
        },
      ],
    },
    email: {
      name: 'email',
      label: 'อีเมล',
      value: null,
    },
    organization: {
      name: 'organization',
      label: 'องค์กรต้นสังกัด',
      value: null,
    },
    values: [
      {
        id: 'xxxx-01',
        sequence: 1,
        preName: 'นาย',
        firstName: 'aaaa',
        lastName: 'bbbbbbb',
        role: 'ผู้ประสานงาน',
        mobileNumber: '0912345678',
        email: 'xxx@mail.com',
        organization: 'XXXXX',
      },
      {
        id: 'xxxx-02',
        sequence: 2,
        preName: 'นาย',
        firstName: 'xx',
        lastName: 'yyy',
        role: 'หัวหน้าทีมพัฒนา',
        mobileNumber: '0912345670',
        email: 'xxx2@mail.com',
        organization: 'XXXXX',
      },
      {
        id: 'xxxx-03',
        sequence: 3,
        preName: 'นาย',
        firstName: 'dd',
        lastName: 'eeee',
        role: 'ผู้ประสานงาน',
        mobileNumber: '0912345671',
        email: 'xxx@mail.com',
        organization: 'XXXXX',
      },
    ],
  },
}
